import React from "react";

import classes from "./Loader.module.scss";

const Loader = (props) => (
	<div className={`${classes.LoaderLayer} ${props.className}`}>
		<svg className={classes.loaderNoku} id="Layer_2" xmlSpace="preserve" version="1.1" viewBox="0 0 41 44" x="0px" xlinkHref="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" y="0px">
			<g className="layer" id="Layer_1"><path className="st0" d="M31.6,27.2c0,8.4-6.8,15.2-15.2,15.2S1.2,35.6,1.2,27.2S8,12,16.4,12h0.1C24.9,12,31.6,18.8,31.6,27.2z" id="Shape_5_" /></g>
			<g className="layer" id="Layer_3"><path className="st0" d="M39.8,9.2c0,2.8-2.3,5-5,5s-5-2.3-5-5s2.3-5,5-5l0,0C37.5,4.2,39.8,6.5,39.8,9.2z" id="Shape_4_" /></g>
			<line className="line st1" x1="31.1" x2="26.8" y1="12.5" y2="16.8" />
		</svg>
	</div>
);

export default Loader;